// Entrée client du front React. Chargée par la page racine
// app/views/layouts/inertia.html.erb (voir ReactFrontend#render_page).
import { createInertiaApp } from '@inertiajs/react'
import { loadTranslations } from '@/app/translations'
import { inertiaOptions } from '@/app/options'
import { installGlobalBehaviours } from '@/app/global'

type InitialPage = { component: string; props: { i18n?: { locale?: string } } }

// Mêmes modules que le résolveur de pages d'Inertia : Vite les dédoublonne, le
// chunk de la page n'est téléchargé qu'une fois.
const pageModules = import.meta.glob('../pages/**/*.tsx')

function initialPage(): InitialPage | null {
  const script = document.querySelector('script[data-page="app"]')
  return script?.textContent ? (JSON.parse(script.textContent) as InitialPage) : null
}

async function boot() {
  const page = initialPage()
  if (!page) return
  // Le chunk de la page part tout de suite, en parallèle des traductions :
  // sur mobile, deux allers-retours successifs retardaient l'hydratation.
  void pageModules[`../pages/${page.component}.tsx`]?.()
  // Les traductions avant le premier rendu : l'hydratation doit produire
  // exactement le HTML rendu par le serveur.
  await loadTranslations(page.props.i18n?.locale || 'en')
  installGlobalBehaviours()

  await createInertiaApp({
    ...inertiaOptions,
    pages: '../pages',
    progress: false,
  })
}

void boot()
